/// <amd-module name="Core/Medius.Core.Web/Scripts/Accounting/TaxHandling/taxHandlingType"/>
export enum TaxHandlingType {
    LineLevelTaxCodes = 0,
    HeadLevelNoTaxCodes = 1,
    HeadLevelTaxCodes = 2,
    LineLevelNoTaxCodes = 3,
}
